export default __webpack_public_path__ + "static/media/transplants.218d637c.png";